import { call, put, takeEvery } from "redux-saga/effects";
import { CANCEL_PAYMENT_LINK } from "resources/actionTypes";
import { cancelPaymentLinkService } from "services/PaymentService";
import { toast } from "react-toastify";
import { getBookingDetails } from "../actions/ReservationAction";

function* fetchCancelPaymentLink(action) {
  try {
    const response = yield call(cancelPaymentLinkService, action.payload);
    if (response?.success) {
      yield put({
        type: CANCEL_PAYMENT_LINK.CANCEL_PAYMENT_LINK_SUCCESS,
      });
      toast.success(response?.message || "Payment link cancelled successfully");
      // Refresh booking details
      yield put(getBookingDetails(action.payload?.tripId));
    } else {
      yield put({
        type: CANCEL_PAYMENT_LINK.CANCEL_PAYMENT_LINK_FAILED,
        message: response?.message,
      });
      toast.error(response?.message || "Failed to cancel payment link");
    }
  } catch (error) {
    yield put({
      type: CANCEL_PAYMENT_LINK.CANCEL_PAYMENT_LINK_FAILED,
      message: error.message,
    });
    toast.error(error.message || "Failed to cancel payment link");
  }
}

export function* cancelPaymentLinkSaga() {
  yield takeEvery(
    CANCEL_PAYMENT_LINK.CANCEL_PAYMENT_LINK_REQUESTED,
    fetchCancelPaymentLink,
  );
}
